//
// IMPORTS
//

// Base URL for the API
import { apiUrl } from '@/constants'

import { httpRequest } from '@/services/api'

//
//
//
// ?
//
//
//

const apiCreateUser = payload => httpRequest({ method: 'POST', url: `${apiUrl}/v1/users`, payload })

//
//
//
// SAÍDA
//
//
//

export {
  apiCreateUser,
}
